
(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("../../addon/regexp/index")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","../../addon/regexp/index"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureBlockReference = this.HyperMD.PreviewFeatureBlockReference || {}), HyperMD.RegExp);
})(function (require, exports, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * ^block-reference
     */
    exports.default = (function (md) {
        // @ts-ignore
        md.inline.ruler.before("escape", "block_reference", function (state, silent) {
            if (!((state.src[state.pos - 1] || "").match(/(^|\s)$/) &&
                state.src[state.pos] === "^" &&
                !state.src[state.pos + 1].match(index_1.BlocKReferenceStopRegExp))) {
                return false;
            }
            var content = "";
            var end = -1;
            var i = state.pos + 1;
            while (i < state.src.length) {
                if (state.src[i].match(index_1.BlocKReferenceStopRegExp)) {
                    if (state.src[i] !== "\n") {
                        return false;
                    }
                    else {
                        end = i;
                        break;
                    }
                }
                else if (state.src[i] === "\\") {
                    i += 1;
                }
                i += 1;
            }
            if (end === -1) {
                end = i;
            }
            if (end >= 0) {
                content = state.src.slice(state.pos, end);
            }
            else {
                return false;
            }
            var token = state.push("block_reference");
            token.content = content;
            token.attrPush(["id", content.slice(1)]);
            state.pos = end;
            return true;
        });
        md.renderer.rules.block_reference = function (tokens, idx) {
            var token = tokens[idx];
            var content = token.content || "";
            var id = token.attrGet("id") || "";
            return "<span class=\"block-reference\" id=\"" + id + "\">" + content + "</span>";
        };
    });
});
